import cx from 'clsx';
import React, { FunctionComponent } from 'react';
import DisqusThread from './DisqusThread';
import styles from './EmbedComments.module.scss';

interface OwnProps {
  url: string;
  identifier: string;
  title: string;
  categoryID: string | number;
}

const EmbedComments: FunctionComponent<OwnProps & JSX.IntrinsicElements['div']> = props => {
  const { className, categoryID, identifier, title, url, ...rest } = props;

  const wrapperClassNames = cx({
    [styles.wrapper]: true,
    ...(className && { [className]: true }),
  });

  return (
    <div className={wrapperClassNames} {...rest}>
      <DisqusThread url={url} id={identifier} title={title} category={`${categoryID}`} shortname={process.env.REACT_APP_DISQUS_SHORTNAME || ''}>
        <p className={styles.content} />
      </DisqusThread>
    </div>
  );
};

export default EmbedComments;
